﻿import { Timeline, Typography, Tag, Space } from 'antd';
import { ClockCircleOutlined, UserOutlined, RobotOutlined } from '@ant-design/icons';
import { formatDate, formatRelativeTime } from '../utils/formatters';
import { STATUS_LABELS } from '../utils/constants';
import type { FSMTransition } from '../types';

const { Text } = Typography;

interface FSMTimelineProps {
  transitions: FSMTransition[];
}

const getActorIcon = (actor: string) => {
  switch (actor) {
    case 'ADMIN':
      return <UserOutlined />;
    case 'SYSTEM':
      return <RobotOutlined />;
    default:
      return <ClockCircleOutlined />;
  }
};

const getActorColor = (actor: string) => {
  switch (actor) {
    case 'ADMIN':
      return 'blue';
    case 'SYSTEM':
      return 'green';
    case 'CLIENT':
      return 'purple';
    default:
      return 'default';
  }
};

export function FSMTimeline({ transitions }: FSMTimelineProps) {
  const items = transitions.map((transition) => ({
    color: transition.to_state.includes('ERROR') ? 'red' : 'blue',
    children: (
      <Space direction="vertical" size={4}>
        <Space>
          <Text strong>
            {STATUS_LABELS[transition.to_state as keyof typeof STATUS_LABELS] || transition.to_state}
          </Text>
          <Tag icon={getActorIcon(transition.actor)} color={getActorColor(transition.actor)}>
            {transition.actor}
          </Tag>
        </Space>
        <Text type="secondary" style={{ fontSize: 12 }}>
          {formatDate(transition.timestamp)} ({formatRelativeTime(transition.timestamp)})
        </Text>
        {Boolean(transition.metadata?.reason) && (
          <Text type="secondary" style={{ fontSize: 12 }}>
            Reason: {String(transition.metadata?.reason ?? '')}
          </Text>
        )}
      </Space>
    )
  }));

  return <Timeline mode="left" items={items} />;
}
